import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

import "./assets/scss/sb-admin-2.scss";
import "./assets/css/style.css";

import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { queryClient } from "./lib/queryClient";

// Détection du callback OAuth Microsoft dans un popup
// Quand Microsoft redirige vers /  avec ?code=xxx, on envoie le code au parent et on ferme
const _msParams = new URLSearchParams(window.location.search);
const _msCode   = _msParams.get('code');
const _msState  = _msParams.get('state');

if (window.opener && _msCode) {
  window.opener.postMessage(
    { type: 'MS_AUTH_CODE', code: _msCode, state: _msState },
    window.location.origin
  );
  window.close();
} else {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode> 
      <QueryClientProvider client={queryClient}>
        <ReactQueryDevtools initialIsOpen={false} />
        <App />
      </QueryClientProvider>
    </React.StrictMode>
  );
}
